import easyCheckApi from '../api/config';

export const pdcAlertService = {
  checkAlerts: async (params = {}) => {
    try {
      const queryParams = {};
      if (params.bankId) queryParams.bankId = params.bankId;
      const response = await easyCheckApi.get('/pdc-alerts/check', {
        params: queryParams,
      });
      const data = response.data;
      return {
        success: data.Success ?? data.success ?? true,
        data: data.Data ?? data.data ?? { HasAlerts: false, Alerts: [] },
      };
    } catch (error) {
      console.error('Failed to check PDC alerts:', error);
      return {
        success: false,
        data: { HasAlerts: false, Alerts: [] },
      };
    }
  },
};

export default pdcAlertService;
